// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/samkalp-admin/SamkalpAdminDashboard.css
 * All rules scoped under .samkalp-admin-shell / namespaced class names to
 * avoid any collision with existing global/Bootstrap classes site-wide.
 */
.samkalp-admin-shell {
    display: flex;
    min-height: 100vh;
    background: #f7f9fc;
    font-family: inherit;
}

.samkalp-admin-sidebar {
    width: 260px;
    flex-shrink: 0;
    background: #092957;
    color: #fff;
    display: flex;
    flex-direction: column;
    padding: 22px 0;
    position: sticky;
    top: 0;
    height: 100vh;
    overflow-y: auto;
}

.samkalp-admin-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 20px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.15);
    margin-bottom: 10px;
}

.samkalp-admin-brand-sun {
    font-size: 22px;
    color: #f1a51c;
}

.samkalp-admin-brand strong {
    display: block;
    font-size: 1rem;
    letter-spacing: 0.03em;
}

.samkalp-admin-brand span {
    display: block;
    color: #f1a51c;
    font-weight: 700;
    font-size: 0.72rem;
}

.samkalp-admin-nav {
    flex: 1 1;
    overflow-y: auto;
}

.samkalp-admin-nav-group {
    margin-bottom: 14px;
}

.samkalp-admin-nav-heading {
    padding: 10px 20px 4px;
    font-size: 0.66rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(255,255,255,0.45);
}

.samkalp-admin-nav-link {
    display: block;
    padding: 9px 20px;
    color: rgba(255,255,255,0.78);
    text-decoration: none;
    font-size: 0.85rem;
    font-weight: 600;
    border-left: 3px solid transparent;
}

.samkalp-admin-nav-link:hover {
    background: rgba(255,255,255,0.06);
    color: #fff;
}

.samkalp-admin-nav-link.active {
    background: rgba(255,255,255,0.12);
    color: #fff;
    border-left-color: #f1a51c;
}

.samkalp-admin-sidebar-footer {
    padding: 14px 20px 0;
    border-top: 1px solid rgba(255,255,255,0.15);
    margin-top: 10px;
}

.samkalp-admin-slug {
    font-size: 0.78rem;
    font-weight: 600;
    opacity: 0.85;
    margin-bottom: 8px;
    word-break: break-all;
}

.samkalp-admin-logout-btn {
    width: 100%;
    background: rgba(255,255,255,0.1);
    border: none;
    color: #fff;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
}

.samkalp-admin-logout-btn:hover {
    background: rgba(255,255,255,0.18);
}

.samkalp-admin-main {
    flex: 1 1;
    padding: 28px 32px;
    overflow-y: auto;
    min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/samkalp-admin/SamkalpAdminDashboard.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":["/* frontend/src/samkalp-admin/SamkalpAdminDashboard.css\n * All rules scoped under .samkalp-admin-shell / namespaced class names to\n * avoid any collision with existing global/Bootstrap classes site-wide.\n */\n.samkalp-admin-shell {\n    display: flex;\n    min-height: 100vh;\n    background: #f7f9fc;\n    font-family: inherit;\n}\n\n.samkalp-admin-sidebar {\n    width: 260px;\n    flex-shrink: 0;\n    background: #092957;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    padding: 22px 0;\n    position: sticky;\n    top: 0;\n    height: 100vh;\n    overflow-y: auto;\n}\n\n.samkalp-admin-brand {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 0 20px 20px;\n    border-bottom: 1px solid rgba(255,255,255,0.15);\n    margin-bottom: 10px;\n}\n\n.samkalp-admin-brand-sun {\n    font-size: 22px;\n    color: #f1a51c;\n}\n\n.samkalp-admin-brand strong {\n    display: block;\n    font-size: 1rem;\n    letter-spacing: 0.03em;\n}\n\n.samkalp-admin-brand span {\n    display: block;\n    color: #f1a51c;\n    font-weight: 700;\n    font-size: 0.72rem;\n}\n\n.samkalp-admin-nav {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.samkalp-admin-nav-group {\n    margin-bottom: 14px;\n}\n\n.samkalp-admin-nav-heading {\n    padding: 10px 20px 4px;\n    font-size: 0.66rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: rgba(255,255,255,0.45);\n}\n\n.samkalp-admin-nav-link {\n    display: block;\n    padding: 9px 20px;\n    color: rgba(255,255,255,0.78);\n    text-decoration: none;\n    font-size: 0.85rem;\n    font-weight: 600;\n    border-left: 3px solid transparent;\n}\n\n.samkalp-admin-nav-link:hover {\n    background: rgba(255,255,255,0.06);\n    color: #fff;\n}\n\n.samkalp-admin-nav-link.active {\n    background: rgba(255,255,255,0.12);\n    color: #fff;\n    border-left-color: #f1a51c;\n}\n\n.samkalp-admin-sidebar-footer {\n    padding: 14px 20px 0;\n    border-top: 1px solid rgba(255,255,255,0.15);\n    margin-top: 10px;\n}\n\n.samkalp-admin-slug {\n    font-size: 0.78rem;\n    font-weight: 600;\n    opacity: 0.85;\n    margin-bottom: 8px;\n    word-break: break-all;\n}\n\n.samkalp-admin-logout-btn {\n    width: 100%;\n    background: rgba(255,255,255,0.1);\n    border: none;\n    color: #fff;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.samkalp-admin-logout-btn:hover {\n    background: rgba(255,255,255,0.18);\n}\n\n.samkalp-admin-main {\n    flex: 1;\n    padding: 28px 32px;\n    overflow-y: auto;\n    min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
